module.exports = {
      id: "bdnews24-logo-usage",
      viewBox: "0 0 770 92",
      url: __webpack_public_path__ + "svg-sprite-147fd1e4cc1faf335e98b31c6ae31fe2.svg#bdnews24-logo",
      toString: function () {
        return this.url;
      }
    }